import extendedConfig from "../../tenants.js";
// Import texts
import _default from './default'
import brainhealthinitiative from './brainhealthinitiative'
import olympianbydesign from './olympianbydesign'

export const tenantTexts = extendedConfig.VUE_TENANT_ID=='brainhealthinitiative'
  ? { ...brainhealthinitiative }
  : extendedConfig.VUE_TENANT_ID=='olympianbydesign'
  ? { ...olympianbydesign }
  : { ..._default }

export default {
  data () {
    return {
      tenantTexts
    }
  }
}
